<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <!-- <p class="order-title-boxs"><span class="blueBlock"></span><i>订单信息</i></p> -->
          <div class="totals-box plr24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">盘点名称</div>
              <div class="itemNum">{{ form.name }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">开始时间</div>
              <div class="itemNum">{{formatDate(form.beginTime)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">结束时间</div>
              <div class="itemNum">{{formatDate(form.endTime)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">盘点类型</div>
              <div class="itemNum">{{ form.checkTypeCn }}</div>
            </div>
          </div>

          <div class="align-items">
            <p class="order-title-boxs">
              <span class="blueBlock"></span><i>盘点产品列表</i>
            </p>
          </div>
          <div class="ml20 mb20">
            <span>未盘点产品({{unCountedList.length}})</span>
          </div>
          <div class="contents-body">
            <el-row class="tables-title">
              <el-col :span="12" class="titles pl10">商品名称</el-col>
              <el-col :span="4" class="titles center">库存数量</el-col>
              <el-col :span="6" class="titles center">盘点数量</el-col>
              <el-col :span="2" class="titles center">操作</el-col>
            </el-row>
            <div class="tables p30 scrollFisrt-auto">
              <div class="boxs" v-for="(item, index) in unCountedList" :key="index">
                <el-row>
                  <el-col :span="12" class="titles pl10">{{ item.productName }}</el-col>
                  <el-col :span="4" class="center">{{ item.productCount }}</el-col>
                  <el-col :span="6" class="center">
                    <p class="align-item">
                      <el-input
                      v-model="item.checkNum"
                      size="mini"
                      style="width: 80px;"
                      maxlength="8"
                      type="digit"
                      @input="inputBigMethod(item)" 
                      @focus="inputFocus(item)"
                    ></el-input><span class="ml10" :class="[item.storageUnit ? '' : 'pr10']">{{ item.storageUnit || '' }}</span></p>
                  </el-col>
                  <el-col :span="2" class="detail center">
                    <!-- <i
                      class="el-icon-delete delete"
                      @click="deleteListSelected(item, index)"
                    ></i> -->
                    <el-link type="primary" @click="onConfirm(item,index,'unCount')">确认</el-link>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="ml20 mt20">
            <span>已盘点产品({{countedList.length}})</span>
          </div>
          <div class="contents-body mt20">
            <el-row class="tables-title">
              <el-col :span="8" class="titles pl10">商品名称</el-col>
              <el-col :span="3" class="titles center">库存数量</el-col>
              <el-col :span="4" class="titles center">盘点情况</el-col>
              <el-col :span="4" class="titles center">盘点数量</el-col>
              <el-col :span="3" class="titles center">盈亏数量</el-col>
              <el-col :span="2" class="titles center">操作</el-col>
            </el-row>
            <div class="tables p30 scrollFisrt-auto">
              <div class="boxs" v-for="(item, index) in countedList" :key="index">
                <el-row>
                  <el-col :span="8" class="titles pl10">{{ item.productName }}</el-col>
                  <el-col :span="3" class="center">{{ item.productNum }}</el-col>
                  <el-col :span="4" class="center">{{item.profitNum >= 0 ? item.profitNum + `(盘盈)` :item.profitNum + `(盘亏)`}}</el-col>
                  <el-col :span="4" class="center" v-show="!item.flag">{{ item.checkNum }}</el-col>
                  <el-col :span="4" class="center" v-show="item.flag">
                    <p class="align-item">
                      <el-input
                      v-model="item.checkNum"
                      size="mini"
                      style="width: 80px;"
                      maxlength="8"
                      type="digit"
                      @input="inputBigMethod(item)" 
                      @focus="inputFocus(item)"
                    ></el-input><span class="ml10" :class="[item.storageUnit ? '' : 'pr10']">{{ item.storageUnit || '' }}</span></p>
                  </el-col>
                  <el-col :span="3" class="center">{{ item.profitNum }}</el-col>
                  <el-col :span="2" class="detail center">
                    <el-link type="primary" @click="onConfirm(item,index,'count')" v-show="item.flag">确认</el-link>
                    <el-link type="primary" @click="item.flag = true" v-show="!item.flag">修改</el-link>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="ml20 mt20">
            <span>盘点照片</span>
          </div>
          <imgUpload
              class="el-form-item-add ml20 mt10"
              @file="getImgFile"
              :limit="3"
              :fileList="form.imgUrlList"
              @delete="deleteImgFile"
              :imgHide="imgHide"
              module="inventory"
            ></imgUpload>
        </div>
        <div class="drawer-footer">
          <div class="btns pr24 pb10" style="display: flex;align-items: center;">
            <el-button type="warning" class="small-btn" @click="cancel('cancel')">盘点作废</el-button>
            <el-button type="primary" class="small-btn" @click="save()">提交盘点</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import imgUpload from "../../../components/common/modules/upload";
export default {
  mixins: [minxin],
  components: { drawer,imgUpload },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      optionName: [], // 请假人
      allStaffList: [], // 请假类型
      form: {
        id: "",
        imgUrlList: [],
      },
      imgHide: true,
      unCountedList: [],
      countedList: []
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.$api.get(this.$url.checkBillInfo.get,{id: org.id}).then(res => {
          if (res) {
            this.commonFunction(res.checkBillItemList)
            this.form = res
          }
        })
        this.addEditShow = true;
        this.addEditTitle = "填写盘点单";
      });
    },
    commonFunction (arr) {
      for (const i in arr) {
        if (arr[i].confirmTime) {
          arr[i].flag = false;
          this.countedList.push(arr[i])
        } else {
          arr[i].flag = false;
          this.unCountedList.push(arr[i])
        }
      }
    },
    getImgFile(res) {
      this.form.imgUrlList.push(res);
      if (this.form.imgUrlList.length >= 3) {
          this.imgHide = false
      }
    },
    deleteImgFile(res) {
      this.form.imgUrlList = res.myFileList;
      this.ossMerchatDelImg(res);
      if (this.form.imgUrlList.length < 3) {
          this.imgHide = true
      }
    },
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    inputBigMethod (e) {
      console.log(e)
      if (e.checkNum == '') {
        return;
      }
      var reg = /^[0-9]\d*$/g;
      if (!reg.test(e.checkNum)) {
        e.checkNum = this.oldAmount;
      } else {
        e.checkNum = Number(e.checkNum) + 0;
        this.oldAmount = e.checkNum;
      }
    },
    inputFocus (e) {
      this.oldAmount = e.checkNum;
    },
    onConfirm (item,index,type) {
        console.log(item);
        if (!String(item.checkNum)) {
          this.$message.error("修改的值不能为空");
          return false;
        }
        if (!/^[0-9]\d*$/.test(item.checkNum)) return this.$message.error("修改的值不能小于0");
        let num = (Number(item.productNum) - Number(item.checkNum)).toFixed(0);
        let obj = {
          itemId: item.id,
          shopId: this.form.shopId,
          productId: item.productId,
          productNum: item.productNum,
          checkNum: item.checkNum,
          profitNum: num,
          checkResult: num > 0 ? 'profit': num == 0 ? 'balance':'loss',
        }
        this.$api.post(this.$url.checkBillItem.save, obj).then(res => {
          if (res) {
            res.flag = false;
            if (type == 'unCount') {
              this.unCountedList.splice(index, 1);
              this.countedList.unshift(res);
            } else {
              this.countedList.splice(index, 1);
              this.countedList.unshift(res);
            }
          }
        })
      },
      save() {
        this.$api.post(this.$url.checkBillInfo.submit, this.form).then(res => {
          if (res) {
            this.addEditShow = false;
            this.$message.success("提交成功");
            this.$emit("change", true);
          }
        })
      },
      cancel (value) {
        let msg;
          if (value == 'refuse') {
            msg = `确定要拒绝吗?`
          } else if (value == 'pass') {
            msg = `确定要同意吗?`
          } else {
            msg = `确定要作废吗?`
          }
          const h = this.$createElement;
          this.$msgbox({
            title: '提示',
            message: h('p', null,[
              h('span', { style: 'color: red' }, msg)
            ]),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true
          }).then(action => {
            this.$api.post(this.$url.checkBillInfo.cancel, {id: this.form.id}).then(res => {
                if (res) {
                  this.addEditShow = false;
                  this.$message.success("作废成功");
                  this.$emit("change", true);
                }
              }).catch(error => {});
        });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.contents-body {
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .tables-title {
    font-size: 14px;
    margin: 0 16px;
    padding: 10px 0;
    font-size: 16px;
    font-weight: 600;
    background: #f7f8fa;
  }

  .scrollFisrt-auto {
    // min-height: 160px;
    // overflow-y: scroll;
  }
  .tables {
    padding: 0 16px 0;
    // max-height: 150px;
    // overflow:auto;
    box-sizing: border-box;
    .boxs {
      min-height: 65px;
      padding: 24px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ebedf0;
      .titles {
        font-weight: 500;
      }
      .money {
        color: @money;
        font-weight: 500;
      }
      .nums {
        /deep/.el-input-number {
          width: 80px;
          .el-input__inner {
            padding: 0 25px;
            height: 22px;
            line-height: 22px;
          }
        }
      }
      .delete {
        font-size: 18px;
        cursor: pointer;
        &:hover {
          color: @blue;
        }
      }
    }
    .right-content {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .staff-btn {
        display: inline-block;
        text-align: center;
        color: #111;
      }
    }
  }
}

.process-boxs {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.process-img {
  width: 40px;
  height: 40px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.audit-img {
  width: 14px;
  height: 14px;
  position: absolute;
  right: 0;
  bottom: 0;
    img {
    width: 100%;
    height: 100%;
  }
}
.process-vertical {
  width: 2px;
  height: 32px;
  margin: 4px 0;
  background: #E6E6E6;
}
.process-right {
  .process-refuse {
    padding: 12px;
    margin-top: 8px;
    color: #666;
    background: #F2F1F6;
    border-radius: 4px;
  }
}

.toggle-text {
  padding: 0 20px;
}
.refund_box {
    background: #fff;
    padding: 10px 20px;
    
    .infos {
      color: #ff892a;
      padding-bottom: 10px;
    }
}
.leaveBox {
  background: #fff;
  padding: 10px 20px;
}
.member_bg {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .el-dialog {
  margin-top: 20vh !important;
}
.pay-mains {
  padding: 0;

  .preImg {
    border-radius: 5px;
    margin: 0 10px 10px 0;
    width: 80px;
    height: 80px;
  }

  .card-ruleForm {
    padding-bottom: 0;
    padding-top: 10px;
    /deep/ .el-form-item {
      border-bottom: 1px solid @borderColor;
      padding: 10px 20px;
      margin-bottom: 0;
      
    }
    .item-cards {
      background: #fff;
      padding: 20px;
      /deep/ .el-form-item__content {
        flex: 2;
        // text-align: right;
        // display: flex;
        margin-left: 0 !important;
        .el-form-item__error {
          right: 0;
        }
      }
    }
    .el-form-item-update {
      align-items: center;
      display: flex;
      margin: 0;
      // justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      background: #fff;
      &:first-child {
        margin-top: 0;
      }
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        // text-align: left;
      }
      /deep/ .el-form-item__content {
        flex: 2;
        text-align: right;
        // display: flex;

        margin-left: 0 !important;
        .el-form-item__error {
          z-index: 1;
          right: 0;
        }
      }

      /deep/ .el-input__inner {
        width: 200px;
          text-align: left;
        // text-align: right;
      }
      
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background: #fff;
      }
      /deep/ .el-link {
        width: 160px;
      }
    }
    .head-img {
    //   height: 90px;
        padding: 10px;
      background: #fff;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dceaed;
      /deep/ .el-form-item__content {
        .top-img {
          width: 100%;
          border-radius: 50%;
          .text-upload {
            position: absolute;
            top: 20px;
            right: 0;
            line-height: initial;
          }
        }
        .el-link {
          width: auto;
          cursor: pointer;
        }
        .img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
  
}
.moneys {
    color: red !important;
}
</style>